window.app = window.app || {};

window.app.countdowns = {
  el: {
    countdowns: document.querySelectorAll('.mt-countdown'),
  },

  init: function () {
    const _this = this;
    if (!_this.el.countdowns) return;

    _this.el.countdowns.forEach((countdown) => {
      const countdownDate = new Date(countdown.dataset.countdown);
      const countdownType = countdown.dataset.type ? countdown.dataset.type : 'html';
      const countdownInterval = setInterval(() => { 
        const timeleft = _this.updateCountdown(countdown, countdownDate, countdownType); 
        if (timeleft <= 0 && countdownInterval) {
          clearInterval(countdownInterval);
          countdown.remove();
        }
      }, 1000);
    });
  },

  updateCountdown: function (countdown, countdownDate, type = 'html') {
    const currentDate = new Date();
    const targetDateInUserTimezone = countdownDate.toLocaleString('en-US', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
    const timeleft = Math.floor((new Date(targetDateInUserTimezone) - currentDate) / 1000);
    const daysAs = countdown.dataset.daysAs;
    let days, hours, minutes, seconds, counterVal;

    if (daysAs === 'd') {
      days = Math.floor(timeleft / 86400);
      hours = Math.floor((timeleft % 86400) / 3600);
      minutes = Math.floor((timeleft % 3600) / 60);
      seconds = Math.floor(timeleft % 60);
    } else {
      days = 0;
      hours = Math.floor(timeleft / 3600);
      minutes = Math.floor((timeleft % 3600) / 60);
      seconds = Math.floor(timeleft % 60);
    }

    if (type === 'html') {
      counterVal = '';
      (days > 0) && (counterVal += `<span data-days><strong>${(days < 10) ? '0' : ''}${days}</strong> days</span>`);
      (hours > 0) && (counterVal += `<span data-hours><strong>${(hours < 10) ? '0' : ''}${hours}</strong> hours</span>`);
      counterVal += `<span data-mins><strong>${(minutes < 10) ? '0' : ''}${minutes}</strong> min.</span>`;
      counterVal += `<span data-secs><strong>${(seconds < 10) ? '0' : ''}${seconds}</strong> sec.</span>`;
    } else {
      const counterArr = [];
      (days > 0) && (counterArr.push(`${days}d`));
      (hours > 0) && (counterArr.push(`${(hours < 10) ? '0' : ''}${hours}h`));
      counterArr.push(`${(minutes < 10) ? '0' : ''}${minutes}m`);
      counterArr.push(`${(seconds < 10) ? '0' : ''}${seconds}s`);
      counterVal = counterArr.join(' ');
    }
    countdown.innerHTML = counterVal;

    return timeleft;
  },
};

window.app.countdowns.init();